import { render, staticRenderFns } from "./PainelProjetosCompras.vue?vue&type=template&id=68394d38"
import script from "./PainelProjetosCompras.vue?vue&type=script&lang=js"
export * from "./PainelProjetosCompras.vue?vue&type=script&lang=js"
import style0 from "./PainelProjetosCompras.vue?vue&type=style&index=0&id=68394d38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports